<template>
    <section>
        <section class="container">
            <div class="title">为河南省第一家智慧加油站喝彩</div>
            <div class="title2">原创：海马行</div>
            <div class="video">
                <video controls poster="../../assets/newActive/zhumadian/){TO]MUD]Q{GQ8$5P)A_7C8.png">
                    <source src="../../assets/newActive/zhumadian/video.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div class="title2">现场采访客户视频，建议在WiFi环境观看，土豪随意</div>
            <div class="article">
                热烈庆祝河南省驻马店中东石化加油站正式升级成为智慧加油站，
                据小编调查中东石化加油站是驻马店唯一一家由本地人开设的加油站，
                开业以来备受客户好评，
                此次升级为智能加油站更是成为本地一大亮点。
                采访站长时，站长表示：“加油站作为我们的服务窗口，每一个加油人员都是我们油站的形象，
                顾客的满意就是我们的追求，我们加油站甚至做到不但让顾客感动，让他们在我们这里倍感舒心，放心。”
            </div>
            <div class="video">
                <img src="../../assets/newActive/zhumadian/img1.jpg" />
            </div>
            <div class="title2">中东石化智慧加油站现场照片</div>
            <div class="article">说到智慧加油站，什么是智慧加油站呢？跟着小编到这里来个360°深入采访吧！</div>
            <div class="article" style="margin-top:-20px;">随着中国新四大发明的普及，像小编我这样，出门不带现金的人恐怕是越来越多了吧~不过有的时候去一些传统的加油站真的只有现金才能支付啊！
            要不然就是只能支付宝或者只能微信，宝宝不开心，宝宝想刷哪个就刷哪个！
            </div>
            <div class="video">
                <img src="../../assets/newActive/zhumadian/img2.jpg" />
            </div>
            <div class="title2">加油站现场照片（海马行收银机/POS机手持收银机）</div>
            <div class="article">
                来到中东石化智慧加油站后，小编任性的甩出支付宝、微信的付款码，
                银行储值卡、信用卡，加了300块的油，又跑到便利店买买买。
                然后抱着一堆东西来到前台
            </div>
            <div class="article" style="margin-top:-20px;">
                前台小美女不慌不忙的拿出扫码枪和POS机，轻轻松松的完成了各种形式的支付，
                还顺便帮我办理了会员卡积了分（我才不会说用积分可以换好多东西呢！）
            </div>
            <div class="article" style="margin-top:-20px;">
                原来智慧加油站就是这么任性的存在啊，一套系统搞定了所有支付方式，还能管理会员、积分等加油站的日常交易管理各项全能。
            </div>
            <div class="video">
                <img src="../../assets/newActive/zhumadian/img3.jpg" />
            </div>
            <div class="title2">海马行收银机及软件</div>
            <div class="article">
                小编打开微信海马行公众号，随时随地地就可以查看到自己刚刚在智慧加油站储值的金额、积分情况，666~~~
            </div>
            <div class="article" style="margin-top:-20px;">
                作为一个好奇宝宝，小编对智慧加油站越来越好奇，决定更深入的进行采访。
                原来智慧加油站可不是我表面看起来的这么简单哦！
            </div>
            <div class="article" style="margin-top:-20px;">
                把多种支付手段聚合起来在一台收银机上使用原来是叫做聚合支付，听上去挺复杂的，聪明如我竟然没有听懂！
                只知道可以任性的选择任何方式进行支付就好啦。
                而且我办理的会员信息随时都可以在微信公众号里查到，
                我每次不管用什么方式消费都能积分，感觉好神奇啊！
            </div>
            <div class="video">
                <img src="../../assets/newActive/zhumadian/img4.jpg" />
            </div>
            <div class="title2">促销礼品/加油员收银现场照片</div>
            <div class="article" style="margin-bottom:60px;">
                小编还了解到智慧加油站不仅仅是聚合支付，同时还兼具着加油站的日常管理，什么油罐油枪啦，
                什么上下班交接啦，什么油量预警啦，员工管理啦，还有一整套商超进销存管理系统。
                小编再次给6个666~~~
            </div>
        </section>
    </section>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .title{
        color: #111;
        font-size: 36px;
        font-weight: 600;
        text-align: center;
        margin-top: 60px;
    }
    .title2{
        color: #888;
        font-size: 14px;
        margin: 12px 0 20px 0;
        text-align: center;
    }
    .video{
        text-align: center;
    }
    .article{
        margin: 20px auto;
        width: 960px;
        font-size: 16px;
        color: #111111;
        line-height: 2.1;
        text-align: left;
    }
    .article:before{
        content: '';
        display: inline-block;
        margin-left: 30px;
    }
</style>
